import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector: 'app-sign-in',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.scss',
})
export class SignInComponent implements OnInit {
    credentials = { email: '', password: '' };
    isLoading = false;
    errorMessage = '';
    isCheckingAuth = false;
    showPassword: boolean = false;

    constructor(private authService: AuthService, private router: Router) {}

    ngOnInit(): void {
        const token = localStorage.getItem('a_id');
        const user = this.authService.getCurrentUser();

        // Jika token & user valid → arahkan ke admin dashboard
        if (token && user) {
            this.router.navigate(['/admin/dashboard'], { replaceUrl: true });
            return;
        }

        // Kalau tidak valid
        localStorage.removeItem('a_id');
        localStorage.removeItem('user');
        this.isCheckingAuth = false;
    }

    async onSignIn(): Promise<void> {
        this.errorMessage = '';

        if (
            !this.credentials.email.trim() ||
            !this.credentials.password.trim()
        ) {
            this.errorMessage = 'Please enter both email and password';
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.credentials.email)) {
            this.errorMessage = 'Please enter a valid email address';
            return;
        }

        this.isLoading = true;

        try {
            const result = await this.authService.signIn(this.credentials);

            if (result) {
                this.isCheckingAuth = false;
                // Setelah login sukses → arahkan ke admin dashboard
                this.router.navigate(['/admin/dashboard'], { replaceUrl: true });
            } else {
                this.errorMessage = 'Invalid email or password';
            }
        } catch (error: any) {
            this.errorMessage =
                error.message || 'An error occurred during login.';
        } finally {
            this.isLoading = false;
        }
    }
}
